import { ListActionType, ListInitialStateType } from "DataTypes/Redux";
import {
  CLEAR_LIST,
  STORE_CASE_TYPE_LIST,
  STORE_ORDER_TYPE_LIST,
} from "./type";

const INITIAL_STATE: ListInitialStateType = {
  OrderTypeDropList: [],
  CaseTypeDropList: [],
};

const reducer = (
  state = JSON.parse(JSON.stringify(INITIAL_STATE)),
  action: ListActionType
) => {
  switch (action.type) {
    case STORE_ORDER_TYPE_LIST:
      return {
        ...state,
        OrderTypeDropList: [...action.payload],
      };
    case STORE_CASE_TYPE_LIST:
      return {
        ...state,
        CaseTypeDropList: [...action.payload],
      };
    case CLEAR_LIST:
      return {
        ...state,
        OrderTypeDropList: [],
        CaseTypeDropList: [],
      };
    default:
      return state;
  }
};

export default reducer;
